/*
* @author 友人a丶
* @date 2022-07-11
*
* 加载axio拦截器
* */
import axios from "axios";
import load from "@/common/load";
import apis from '@/service/api';
import api from '@/service/api';
import quitSystem from './quit-system'
import config from "@/config";

/*
* 是否需要注册认证头
* */
if (config.auth.mode === "token") {
    // 登录的Token保存
    const xsrfHeaderName = config.auth.token; //认证头的名字
    axios.defaults.timeout = 120000;
    axios.defaults.withCredentials = true;
    axios.defaults.xsrfHeaderName = xsrfHeaderName;
    axios.defaults.xsrfCookieName = xsrfHeaderName;
    axios.defaults.baseURL = api.host;
}


// 不需要拦截的接口
const ignoreApi = {
    api: [
        apis.login.user
    ],
    includes(api) {

        /*
        * 判断当前请求的接口是否在忽略列表
        * */
        for (let item of ignoreApi.api) {
            let reg = new RegExp(`.*${item}.*`);
            if (reg.test(api)) {
                return true;
            }
        }
        return false;
    }
}

/*
* 注册响应拦截器
* */
export default function () {
    console.log("加载拦截器...");

    let timer = null; //计时器


    axios.interceptors.response.use(function (res) {

        /*
        * 判断用户登录是否失效
        * */
        if (res.data.code === 200 || res.data.code === 1) {
            res.data.code = 1;
        } else if (res.data.code === 100) {
            res.data.code = 0;
        } else {
            res.data.code = -1;
        }

        /* 处理 */
        if (res.data.message) {
            res.data.errMsg = res.data.message;
            delete res.data.message; //移除
        }


        return res;
    });


    /**
     * 专门处理获取用户信息的接口
     */
    axios.interceptors.response.use(function (res) {
        /* 对接口进行处理 */
        if (res.config.url === api.login.info) {
            /* 获取cookie */
            if (res.data.code === -1) {
                res.data.code = 0;
            }
        }
        return res;
    });


    axios.interceptors.response.use(function (res) {

        console.log("请求接口：" + res.config.url)
        console.log(res);
        console.log("登录", res.data.code)

        /*
        * 判断是否需要拦截
        * */
        if (ignoreApi.includes(res.config.url)) {
            return res;
        }

        // 如果是401(没有token/token过期) 就跳转登录界面重新登录
        if (res.data.code === -1) {
            res.data.code = 0;//转换为正常失败代码
            timer = setTimeout(() => {
                if (timer) clearTimeout(timer);//清理还未运行的定时器
                load.confirm("当前登录状态已失效，请您重新登录！", () => {
                    clearTimeout(timer); //清理运行完毕的定时器
                    quitSystem(false); //退出登录
                });
            }, 500)
        }

        return res;
    });


    axios.interceptors.request.use(function (request) {
        console.log(request)
        return request;
    });

}
